<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <create-administrator-form @on-submit="onCreateAdministratorSubmit"></create-administrator-form>
    </div>
  </div>
</template>
<script>
  import CreateAdministratorForm from '../Forms/CreateAdministratorForm.vue'
  import swal from 'sweetalert2'

  export default {
    components: {
      CreateAdministratorForm
    },
    methods: {
      onCreateAdministratorSubmit (model, isValid) {
        if (isValid) {
          var self = this
          var formData = new FormData();
          formData.append('name', model.name);
          formData.append('email', model.email);
          formData.append('password', model.password);
          if (model.image) formData.append('image', model.image);
          var xhr = new XMLHttpRequest()
          xhr.open('POST', self.$root.apiUrl + 'v1/admins')
          xhr.setRequestHeader('Authorization', localStorage.getItem('token'))
          xhr.onload = function () {
            if (xhr.status === 401) self.$router.push({name: 'Login'})
            var response = JSON.parse(xhr.responseText)
            if (xhr.status === 201) {
              self.notifyVue('top','right')
              self.$router.push({name: 'Administrators'})
            } else {
              var message
              if (response.response && response.response[0] && response.response[0].message)
                message = response.response[0].message
              else
                message = 'Unknown error'
              self.showSweetAlertError(message)
            }
          }
          xhr.send(formData)
        }
      },
      showSweetAlertError (message) {
        swal({
          title: 'An error occured!',
          text: message,
          type: 'warning',
          showConfirmButton: false,
          showCancelButton: true,
          cancelButtonText: 'Try again',
          cancelButtonClass: 'md-button md-success',
          buttonsStyling: false
        })
      },
      notifyVue (verticalAlign, horizontalAlign) {
        this.$notify(
          {
            message: 'Administrator created succesfully.',
            icon: 'person_add',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: 'success'
          }
        )
      }
    }
  }
</script>
<style>
</style>
